// in src/App.js
import React, { Component } from 'react';
import { Admin, Resource } from 'react-admin';
import createDataProvider from './dataProvider';
import authProvider from './authProvider';

import Dashboard from './Dashboard';

import { CompanyEditView, CompanyList, CompanyShow } from './components/company';
import { ProjectEditView, ProjectList, ProjectShow } from './components/projects';
import { TranslationCreate, TranslationEdit, TranslationList } from './components/translation'
import { ReportTemplateCreate, ReportTemplateEdit, ReportTemplateList } from './components/reportTemplate'
import { RuleDefinitionCreateView, RuleDefinitionEditView, RuleDefinitionList } from "./components/ruleDefinition";
import { SheetShow, SheetEditView, SheetList } from "./components/Sheet";
import { UserEditView, UserList, UserView } from "./components/user";
import { GroupCreate, GroupEdit, GroupList, GroupView } from "./components/groups";
import { RecordListView, RecordView } from "./components/records"
import { FeatureFlagList, FeatureFlagShow } from "./components/featureFlag";
import { DescriptionEdit, DescriptionList, DescriptionShow } from "./components/description";
import { ImportConfigList, ImportConfigEdit, ImportConfigCreate } from "./components/importConfig";
import { RecordsHistoryListView } from "./components/transactionHist";
import { CompanyProjectPayerList, CompanyProjectPayerShow } from "./components/companyProjectPayer";

import { DrawingsList, DrawingsView } from "./components/drawings";

import { HealthMetricsList } from './components/healthMetrics/healthMetrics';

import PeopleIcon from '@material-ui/icons/People';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import TranslateIcon from '@material-ui/icons/Translate';
import AssessmentIcon from '@material-ui/icons/Assessment';
import BusinessIcon from '@material-ui/icons/Business';
import StoreMallDirectoryIcon from '@material-ui/icons/StoreMallDirectory';
import FlagIcon from '@material-ui/icons/Flag';
import ListAltIcon from '@material-ui/icons/ListAlt';
import ImageAspectRatioIcon from '@material-ui/icons/ImageAspectRatio';
import PaymentIcon from '@material-ui/icons/Payment';
import './utils/sentry'

class App extends Component {
  constructor() {
    super();
    this.state = {
      dataProvider: null,
    };
  }

  componentDidMount() {
    createDataProvider()
      .then((dataProvider) => this.setState({ dataProvider }))
      .catch(() => {
        this.setState({
          dataProvider: () => createDataProvider()
            .then((dataProvider) => this.setState({ dataProvider })),
        });
      });
  }

  render() {
    const { dataProvider } = this.state;

    if (!dataProvider) {
      return <div>Loading...</div>;
    }

    return (
      <Admin dashboard={Dashboard} authProvider={authProvider} dataProvider={dataProvider} disableTelemetry>
        <Resource options={{ label: 'Health Metrics' }}
                  name='HealthMetrics'
                  list={HealthMetricsList} />
        <Resource name="Company" list={CompanyList} show={CompanyShow} edit={CompanyEditView} icon={StoreMallDirectoryIcon}/>
        <Resource name="Project" list={ProjectList} show={ProjectShow} edit={ProjectEditView} icon={BusinessIcon}/>
        <Resource options={{ label: 'Collaborators'}} name={'CompanyProjectPayer'} list={CompanyProjectPayerList} show={CompanyProjectPayerShow} icon={PaymentIcon}/>
        <Resource name="FeatureFlag" list={FeatureFlagList} show={FeatureFlagShow} icon={FlagIcon} />
        <Resource name="ReportTemplate" options={{ label: 'Report Templates' }} title="Report Templates"
                  list={ReportTemplateList}
                  edit={ReportTemplateEdit}
                  create={ReportTemplateCreate}
                  icon={AssessmentIcon}
        />
        <Resource name="Translation" list={TranslationList} edit={TranslationEdit} create={TranslationCreate} icon={TranslateIcon}/>
        <Resource options={{ label: 'Automation Rules' }} name='RuleDefinitionListValue' list={RuleDefinitionList}
                  create={RuleDefinitionCreateView} edit={RuleDefinitionEditView} icon={SettingsApplicationsIcon}/>
        <Resource options={{ label: 'Sheets' }} name='Sheet' list={SheetList} show={SheetShow}
           icon={SettingsApplicationsIcon}/>
        <Resource name={'RecordType'} />
        <Resource name={'User'} list={UserList} show={UserView} edit={UserEditView} icon={PeopleIcon}/>
        <Resource name={'Group'} list={GroupList} show={GroupView} create={GroupCreate} edit={GroupEdit} icon={GroupWorkIcon}/>
        <Resource name={'Drawing'} list={DrawingsList} show={DrawingsView} icon={ImageAspectRatioIcon}/>
        <Resource name="Record" list={RecordListView} show={RecordView} />
        <Resource options={{ label: 'Record History' }} name="RecordsValueHistory" list={RecordsHistoryListView} />
        <Resource name={'Description'} list={DescriptionList} edit={DescriptionEdit} show={DescriptionShow} icon={ListAltIcon}/>
        <Resource options={{ label: 'Import Config' }} name='ImportConfig' title="Import Config" list={ImportConfigList} edit={ImportConfigEdit} create={ImportConfigCreate} icon={ListAltIcon}/>
      </Admin>
    );
  }
}

export default App;
